/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, { enumMixn } from './enumItem';

/**
 * 运维审核类型
 */
let EnumCompareTaskStatus = {
    待确定: new EnumItem('待确定', 1),
    待派发: new EnumItem('待派发', 2),
    已派发: new EnumItem('已派发', 3),
    已处理: new EnumItem('已处理', 4),
    // 已反馈: new EnumItem('已反馈', 5),
    ...enumMixn,
};
export default EnumCompareTaskStatus;

export const EnumCompareTaskConfirmStatus = {
    现场条件不允许: new EnumItem('现场条件不允许', 2),
    现场条件允许: new EnumItem('现场条件允许', 1),
    ...enumMixn,
};

export const EnumCompareTaskDealStatus = {
    已处理: new EnumItem('已处理', 2),
    未处理: new EnumItem('未处理', 1),
    ...enumMixn,
};
